function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { radioAnatomy as parts } from "@chakra-ui/anatomy";
import { ThemedCheckbox as Checkbox } from "./Checkbox";
export { Radio, RadioGroup, useRadio, useRadioGroup } from "@chakra-ui/react";
const { control = {} } = Checkbox.baseStyle;
const baseStyleControl = _object_spread_props(_object_spread({}, control), {
    borderRadius: 'full',
    boxSizing: 'content-box',
    _checked: _object_spread_props(_object_spread({}, control['_checked']), {
        _hover: _object_spread_props(_object_spread({}, control['_checked']['_hover']), {
            bg: 'background.neutral.secondary.hovered'
        }),
        bg: 'inherit',
        _before: {
            content: `""`,
            display: 'inline-block',
            pos: 'relative',
            w: '50%',
            h: '50%',
            borderRadius: '50%',
            bg: control['_checked'].bg
        }
    })
});
const baseStyle = {
    label: Checkbox.baseStyle.label,
    control: baseStyleControl
};
const sizes = {
    md: {
        control: {
            w: '20px',
            h: '20px'
        },
        label: {
            fontSize: 'md'
        }
    },
    lg: {
        control: {
            w: '24px',
            h: '24px'
        },
        label: {
            fontSize: 'lg'
        }
    },
    sm: {
        control: {
            width: '16px',
            height: '16px'
        },
        label: {
            fontSize: 'sm'
        }
    }
};
const defaultProps = {
    size: 'md'
};
export const ThemedRadio = {
    parts: parts.keys,
    baseStyle,
    sizes,
    defaultProps
};

//# sourceMappingURL=Radio.js.map